import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import About from "./About";
import AboutMobile from "./AboutMobile";
import { motion } from "framer-motion";
import Social from "../Social";

function MainAbout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
      style={{ width: "100%" }}
    >
      <Social />
      {!isMobile && <About />}
      {isMobile && <AboutMobile />}
    </motion.div>
  );
}

export default MainAbout;
